import { api } from "./client.js";
export const credentialsApi = {
    list: () => api.get("api/credentials").json(),
    add: (body) => api.post("api/credentials", { json: body }).json(),
    probe: (body) => api.post("api/credentials/probe", { json: body }).json(),
    test: (id) => api
        .post(`api/credentials/${id}/test`)
        .json(),
    delete: (id) => api.delete(`api/credentials/${id}`),
};
